import { IApplicationState } from '../../types/redux';

export const selectOffersFetchingMode = (state: IApplicationState) => {
  return state.listingModal.offersFetchingMode;
};
